<script>
import Signup from "@/views/modals/Signup";
import Login from "@/views/modals/Login";

export default {
  components: {
    Signup,
    Login,
  },
};
</script>

<template>
  <div class="mt-10 flex flex-col-reverse lg:flex-row">
    <Signup />
    <div class="hidden lg:block border-l border-solid mx-5 border-gray-400 h-500" />
    <Login />
  </div>
</template>
